import firebase from 'firebase'
import 'firebase/analytics'
import 'firebase/firestore'

const environment = process.env.NODE_ENV || 'local'
const envSet = require(`../../env.${environment}.js`)

firebase.initializeApp(
  envSet.config
)
firebase.analytics()
const db = firebase.firestore()
export default db
